"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = exports.ModalWidth = void 0;

var _themeGet = require("@styled-system/theme-get");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _svgs = require("../../svgs");

var _ArtsyLogoBlackIcon = require("../../svgs/ArtsyLogoBlackIcon");

var _Box = require("../Box");

var _Flex = require("../Flex");

var _Join = require("../Join");

var _Spacer = require("../Spacer");

var _Text = require("../Text");

var _useSentinelVisibility = require("../../utils/useSentinelVisibility");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ModalWidth;
/**
 * Modal.
 * Spec: https://www.figma.com/file/m6gDpKHEWDbYJyrwsVZDBr/Artsy-3.0-Design-System?node-id=6150%3A7290
 * @deprecated: Use `ModalDialog` instead
 */

exports.ModalWidth = ModalWidth;

(function (ModalWidth) {
  ModalWidth["Narrow"] = "300px";
  ModalWidth["Normal"] = "440px";
  ModalWidth["Wide"] = "900px";
})(ModalWidth || (exports.ModalWidth = ModalWidth = {}));

var Modal = function Modal(_ref) {
  var children = _ref.children,
      FixedButton = _ref.FixedButton,
      title = _ref.title,
      show = _ref.show,
      modalWidth = _ref.modalWidth,
      isWide = _ref.isWide,
      hasLogo = _ref.hasLogo,
      onClose = _ref.onClose,
      hideCloseButton = _ref.hideCloseButton;
  var wrapperRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      fadeIn = _useState2[0],
      setFadeIn = _useState2[1];

  var _useSentinelVisibilit = (0, _useSentinelVisibility.useSentinelVisibility)(),
      sentinel = _useSentinelVisibilit.sentinel,
      isScrolled = _useSentinelVisibilit.isSentinelVisible;

  var handleEscapeKey = function handleEscapeKey(event) {
    if (event && event.key === "Escape") {
      onClose();
    }
  };

  (0, _react.useEffect)(function () {
    if (show) {
      setFadeIn(true);

      if (!hideCloseButton) {
        // Binds key event for escape to close modal
        document.addEventListener("keyup", handleEscapeKey, true);
      } // Fixes the body to disable scroll


      document.body.style.overflowY = "hidden";
    } else {
      setFadeIn(false);
      document.body.style.overflowY = "visible";
      document.removeEventListener("keyup", handleEscapeKey, true);
    }

    return document.removeEventListener("keyup", handleEscapeKey, true);
  }, [show]);

  var handleWrapperClick = function handleWrapperClick(event) {
    // If modal X icon is hidden we don't want to close the modal when the wrapper is clicked
    if (!hideCloseButton && event.target === wrapperRef.current) {
      onClose();
    }
  };

  if (!show) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ModalOuterWrapper, {
    show: show,
    className: fadeIn ? "fadeIn" : ""
  }, /*#__PURE__*/_react.default.createElement(ModalWrapper, {
    ref: wrapperRef,
    onClick: handleWrapperClick
  }, /*#__PURE__*/_react.default.createElement(ModalElement, {
    modalWidth: modalWidth,
    isWide: isWide,
    show: show,
    className: fadeIn ? "fadeIn" : ""
  }, /*#__PURE__*/_react.default.createElement(ModalFlexContent, null, /*#__PURE__*/_react.default.createElement(ModalStickyHeader, {
    position: "sticky",
    top: 0,
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    isScrolled: isScrolled,
    px: 2
  }, /*#__PURE__*/_react.default.createElement(_Spacer.Spacer, {
    my: 1
  }), /*#__PURE__*/_react.default.createElement(_Flex.Flex, null, /*#__PURE__*/_react.default.createElement(_Box.Box, {
    pr: 6,
    flex: 1
  }, /*#__PURE__*/_react.default.createElement(_Join.Join, {
    separator: /*#__PURE__*/_react.default.createElement(_Spacer.Spacer, {
      py: 1
    })
  }, hasLogo && /*#__PURE__*/_react.default.createElement(Logo, {
    my: 1
  }), title && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "lg",
    color: "black100",
    py: hasLogo ? 0 : 1
  }, title))), !hideCloseButton && /*#__PURE__*/_react.default.createElement(CloseIconWrapper, {
    my: 1,
    onClick: function onClick() {
      return onClose();
    }
  }, /*#__PURE__*/_react.default.createElement(_svgs.CloseIcon, {
    fill: "black60"
  }))), /*#__PURE__*/_react.default.createElement(_Spacer.Spacer, {
    py: 1
  })), /*#__PURE__*/_react.default.createElement(ModalScrollContent, {
    hasLogo: hasLogo,
    modalWidth: modalWidth,
    px: 2,
    py: 1,
    pb: 2
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, sentinel, children)), FixedButton && /*#__PURE__*/_react.default.createElement(FixedButtonWrapper, {
    isScrolled: isScrolled,
    p: 2
  }, FixedButton))))));
};

exports.Modal = Modal;
var FixedButtonWrapper = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "Modal__FixedButtonWrapper",
  componentId: "qjtwq0-0"
})(["box-shadow:", ";flex:0 0 auto;transition:box-shadow 250ms ease-in-out;"], function (_ref2) {
  var isScrolled = _ref2.isScrolled;
  return isScrolled ? _helpers.DROP_SHADOW : "none";
});
var ModalOuterWrapper = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Modal__ModalOuterWrapper",
  componentId: "qjtwq0-1"
})(["position:fixed;top:0;left:0;z-index:9999;width:100vw;height:100vh;background-color:rgba(229,229,229,0.5);opacity:0;pointer-events:", ";&.fadeIn{transition:opacity 250ms ease;transition-delay:1ms;opacity:1;}"], function (props) {
  return props.show ? "auto" : "none";
});
var ModalWrapper = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "Modal__ModalWrapper",
  componentId: "qjtwq0-2"
})(["position:relative;width:100%;height:100%;overflow:hidden;justify-content:center;align-items:center;"]);
var ModalElement = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "Modal__ModalElement",
  componentId: "qjtwq0-3"
})(["position:absolute;height:", ";max-height:calc(100vh - 80px);min-height:58px;overflow:hidden;background-color:", ";box-shadow:", ";width:", ";", ";transform:translateY(2000px);&.fadeIn{transition:all 400ms cubic-bezier(0.075,0.82,0.165,1);transition-delay:1ms;transform:translateY(0px);}"], function (props) {
  return props.height ? props.height : "auto";
}, (0, _themeGet.themeGet)("colors.white100"), _helpers.DROP_SHADOW, function (props) {
  return props.modalWidth || (props.isWide ? ModalWidth.Wide : ModalWidth.Normal);
}, _helpers.media.xs(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    max-height: 100vh;\n    height: calc(100vh - ", ");\n    width: calc(100vw - ", ");\n  "])), (0, _themeGet.themeGet)("space.4"), (0, _themeGet.themeGet)("space.4")));
var ModalFlexContent = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "Modal__ModalFlexContent",
  componentId: "qjtwq0-4"
})(["position:relative;flex-direction:column;width:100%;overflow:hidden;max-height:calc(100vh - 80px);", ";"], _helpers.media.xs(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    max-height: 100vh;\n  "]))));
var ModalStickyHeader = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Modal__ModalStickyHeader",
  componentId: "qjtwq0-5"
})(["box-shadow:", ";transition:box-shadow 250ms ease-in-out;"], function (_ref3) {
  var isScrolled = _ref3.isScrolled;
  return isScrolled ? _helpers.DROP_SHADOW : "none";
});
var ModalScrollContent = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "Modal__ModalScrollContent",
  componentId: "qjtwq0-6"
})(["overflow:auto;flex-direction:column;"]);
var CloseIconWrapper = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "Modal__CloseIconWrapper",
  componentId: "qjtwq0-7"
})(["cursor:pointer;"]);
var Logo = (0, _styledComponents.default)(_ArtsyLogoBlackIcon.ArtsyLogoBlackIcon).withConfig({
  displayName: "Modal__Logo",
  componentId: "qjtwq0-8"
})(["width:78px;"]);
Modal.displayName = "Modal";
ModalWrapper.displayName = "ModalWrapper";
ModalScrollContent.displayName = "ModalScrollContent";
//# sourceMappingURL=Modal.js.map